import React, { useState } from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const LanguageSwitcher = () => {
  const {
    language,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const languages = [{
    code: 'pt' as const,
    name: 'Português',
    flag: '🇵🇹'
  }, {
    code: 'en' as const,
    name: 'English',
    flag: '🇺🇸'
  }];
  const currentLanguage = languages.find(lang => lang.code === language);
  return <div className="relative" data-id="element-175">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-176">
        <GlobeIcon className="h-5 w-5 text-gray-600" data-id="element-177" />
        <span className="text-sm font-medium text-gray-700" data-id="element-178">
          {currentLanguage?.flag}
        </span>
      </button>

      {isOpen && <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} data-id="element-179" />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20" data-id="element-180">
            {languages.map(lang => <button key={lang.code} onClick={() => {
          setLanguage(lang.code);
          setIsOpen(false);
        }} className={`w-full flex items-center space-x-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${language === lang.code ? 'bg-blue-50 text-primary font-medium' : 'text-gray-700'}`} data-id="element-181">
                <span className="text-xl" data-id="element-182">{lang.flag}</span>
                <span data-id="element-183">{lang.name}</span>
                {language === lang.code && <span className="ml-auto text-primary" data-id="element-184">✓</span>}
              </button>)}
          </div>
        </>}
    </div>;
};
export default LanguageSwitcher;